'use client';

import classes from '@/components/Form/CancellationRetention/CancellationRetentionTeaser.module.scss';
import {
  RETENTION_MOBILE_CTA_LABEL,
  isRetentionProductSelected,
} from '@/components/Form/CancellationRetention/cancellationRetentionHelper';
import {
  useCancellationRetentionCtaClick,
  useCancellationRetentionImpression,
} from '@/components/Form/CancellationRetention/useCancellationRetentionTracking';
import { useCancellationRetentionViewport } from '@/components/Form/CancellationRetention/useCancellationRetentionViewport';
import { Button } from '@/components/button';
import { useSettings } from '@/providers/SettingsProvider';
import type { FormStoryblok } from '@/types/component-types-sb';
import { type FC } from 'react';

type CancellationRetentionMobileButtonProps = {
  productValue: unknown;
  blok: FormStoryblok;
};

const CancellationRetentionMobileButton: FC<CancellationRetentionMobileButtonProps> = ({ productValue, blok }) => {
  const settings = useSettings();
  const { isDesktop, isReady } = useCancellationRetentionViewport();
  const isEligible = isRetentionProductSelected(productValue, blok);

  useCancellationRetentionImpression(
    isReady && isEligible && !isDesktop,
    isEligible,
    RETENTION_MOBILE_CTA_LABEL,
    settings
  );

  const handleClick = useCancellationRetentionCtaClick(settings, RETENTION_MOBILE_CTA_LABEL);

  if (!isReady || isDesktop || !isEligible) {
    return null;
  }

  return (
    <span className={classes.mobileOnly}>
      <Button variant="ctaWhite" data-testid="cancellation-retention-mobile-button" onClick={handleClick}>
        {RETENTION_MOBILE_CTA_LABEL}
      </Button>
    </span>
  );
};

export default CancellationRetentionMobileButton;
